import React from 'react'
import { Icon, Typography } from '@vp/swan'
import { useSocialMediaGallery } from '~/client/hooks/useSocialMediaGallery'
import { useTranslations } from '~/client/hooks/useTranslations'
import { useSelector } from 'react-redux'
import { getProductKey, getProductVersion, getLocaleSelector, getMarket, getQuantitySelector } from 'client/store/config'
import { PRICING_PRESENTATION_TYPES } from '~/client/constants'
import { ContextualBatchPricePlatform } from '~/client/components/common/PricingDisplay/PricePlatform/ContextualBatchPricePlatform'
import { PageId } from '@vp/price-platform'

export type PropTypes = Gallery.Analytics.ButtonLocationProp &
  React.HTMLProps<HTMLElement> & {
    productOptionsByKey: Gallery.Product.ProductOptionsGroupsByProductKey | null
    pricingPresentationType?: string | null
  }

export const UploadTile = (props: PropTypes) => {
  const { productOptionsByKey, pricingPresentationType = PRICING_PRESENTATION_TYPES.QTY_FROM_PRICE } = props

  const localize = useTranslations()
  const locale = useSelector(getLocaleSelector)
  const market = useSelector(getMarket)
  const productKey = useSelector(getProductKey)
  const productVersion = useSelector(getProductVersion)
  const quantity = useSelector(getQuantitySelector)
  const shouldHideForSocialMedia = useSocialMediaGallery()

  return (
    <div className="clickable tile-action-area fbu-action-area" data-testid="fbu-tile" role="presentation">
      <div className="fbu-content">
        <div className="fbu-upload-icon-circle">
          <Icon className="fbu-upload-icon" iconType="upload" />
        </div>

        <Typography className="fbu-header-text" fontWeight="bold">
          {localize('FullBleedUploadTileHeader')}
        </Typography>

        <Typography className="caption-text">
          {!shouldHideForSocialMedia && (
            <ContextualBatchPricePlatform
              locale={locale}
              market={market}
              pageId={PageId.Gallery}
              pricingPresentationType={pricingPresentationType}
              productKey={productKey}
              productOptionsByProductKey={productOptionsByKey}
              productOptionsHash={Object.keys(productOptionsByKey?.[productKey] ?? {})?.[0]}
              productVersion={productVersion || undefined}
              quantity={quantity}
            />
          )}
        </Typography>
      </div>
    </div>
  )
}
